import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polyline, Marker, Tooltip, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Custom Minimalist Icons (Uber-style)
const startIcon = new L.DivIcon({
  html: `<div style="background-color: #0f172a; width: 12px; height: 12px; border-radius: 50%; border: 2px solid #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
  className: '',
  iconSize: [12, 12],
  iconAnchor: [6, 6]
});

const endIcon = new L.DivIcon({
  html: `<div style="background-color: #06b6d4; width: 14px; height: 14px; border: 2px solid #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>`,
  className: '',
  iconSize: [14, 14],
  iconAnchor: [7, 7]
});

export default function RouteMap({ startCoords, endCoords, isDarkMode, startLabel = "Departure",
  endLabel = "Destination" }) {
  const [routeCoords, setRouteCoords] = useState([]);

  useEffect(() => {
    if (!startCoords || !endCoords) return;

    // OSRM Free Public API (Format: longitude,latitude)
    const url = `https://router.project-osrm.org/route/v1/driving/${startCoords[1]},${startCoords[0]};${endCoords[1]},${endCoords[0]}?overview=full&geometries=geojson`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.routes && data.routes[0]) {
          // OSRM returns GeoJSON [lng, lat], Leaflet needs [lat, lng]
          const coords = data.routes[0].geometry.coordinates.map(c => [c[1], c[0]]);
          setRouteCoords(coords);
        }
      })
      .catch(err => console.error("Routing error:", err));
  }, [startCoords, endCoords]);

  // Premium, clean map tiles that adapt to your theme
  const tileUrl = isDarkMode
    ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
    : "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";

    const tooltipClass = isDarkMode ? "custom-tooltip-dark" : "custom-tooltip-light";

  return (
    <MapContainer
      bounds={[startCoords, endCoords]}
      boundsOptions={{ padding: [20, 20] }} // Keeps route nicely in frame
      zoomControl={false}
      dragging={false}
      scrollWheelZoom={false}
      style={{ height: "100%", width: "100%", zIndex: 1, backgroundColor: isDarkMode ? '#0f172a' : '#f8fafc' }}
      attributionControl={false}
    >
      <TileLayer url={tileUrl} />
      
      {/* The Route Line */}
      {routeCoords.length > 0 && (
        <Polyline positions={routeCoords} color="#06b6d4" weight={4} opacity={0.9} />
      )}
      
      {/* Start and End Markers */}
      <Marker position={startCoords} icon={startIcon} />
      <Marker position={endCoords} icon={endIcon} />
      
       
    </MapContainer>
  );
}